/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:6833956c-7b03-43ae-a0a0-340889033108",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_FgDOa3Vx4",
    "aws_user_pools_web_client_id": "5bpc7h2aup5vsnsl0k0936a7j",
    "oauth": {},
    "aws_cognito_login_mechanisms": [
        "EMAIL"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://lvkoqo4cafhtjffrbzbeyvozym.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "unidesigncompassapp38d5a61bf2244355a49f78f038a747ef-udcprod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
